import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { RewardsBanner, CustomerProfile } from '@/models';

@Component({
  name: 'CmgLoyaltyBannerRewardsPage',
})
export default class CmgLoyaltyBannerRewardsPage extends Vue {
  get shouldDisplayBanner(): boolean {
    return !this.isCanadian;
  }

  get rewardsBannerData(): RewardsBanner {
    return this.isEnrolledInLoyalty ? this.$services.config.getRewardsPageGuacModeRewardsBanner() : this.$services.config.getRewardsPageGuestUnenrolledRewardsBanner();
  }

  get customer(): CustomerProfile | null {
    const profile = this.$appStore.state.customer.profile;
    return profile && !profile.isGuest ? profile : null;
  }

  get isCanadian() {
    return this.customer && this.customer.country == 'CA';
  }

  get isEnrolledInLoyalty() {
    return this.$services.loyalty.isEnrolledInLoyalty(this.customer);
  }
}
